import { Box, Dialog, Fade, Grid, Slide, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { TransitionProps } from "@material-ui/core/transitions";
import React, { useEffect } from "react";
import { UIOverlayViewStatus } from "common-ts/dist/models/UIOverlayViewStatus";
import { BodyMeasurements, BodyMeasurementsForSize, CalculateClothBodyMeasurementsFromBodyMeasurements, ClothingType, FitType } from "common-ts/dist/models/UserMeasurements";
import { useAppDispatch, useAppSelector } from "../reduxhooks";
import { FlowComponentMaster } from "./OverlayViewOfflineSharescreenBlocks";
import { OfflineActiveScreen, updateCurrentScreen } from "../redux/UIOverlayOfflineRedux";
import { openOverlay } from "../redux/UIOverlayOfflineRedux";
import { useHistory } from "react-router-dom";
import { RegularSizeValue } from "common-ts/dist/models/Cart";
import { checkAndRequestMicrophonePermission } from "../redux/MicrophoneRedux";
import { loadAllIframeVariablesFromLocalStorage } from "../redux/CartRedux";
import PageElementProduct from "./PageComponentElementProduct";
import ReactHtmlParser from 'react-html-parser';
import Countdown from 'react-countdown';
import { AlternatingImgCarsl } from './PageComponentElementProduct';
import { UkuranBadanCardMini } from './PageProductDetailSizeOptions';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogContainer: {
            zIndex: (theme.zIndex.modal + 1 + " !important") as any,
        },
        dialogContentContainer: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
            alignItems: "flex-start",
        },
        dialogContentLeftContainer: {
            width: "46%",
            paddingLeft: "29%",
            [theme.breakpoints.only("xs")]: {
                paddingLeft: "0%",
                width: "100%",
                justifyContent: "center",
            },
            display: "flex",
            justifyContent: "space-between",
        },
        titleLogoContainer: {
            width: "100%",
            position: "relative",
            paddingTop: "2.5vw",
            paddingBottom: "6vw",
            height: "5vw",
            [theme.breakpoints.only("xs")]: {
                paddingTop: "5vw",
                paddingBottom: "7vw",
                height: "10vw",
            },
            cursor: "pointer",
        },
        titleLogoDesktop: {
            paddingTop: "1.5vw",
            height: "5vw",
            [theme.breakpoints.only("xs")]: {
                paddingTop: "3vw",
                height: "10vw",
            },
        },
        titleLogoClose: {
            position: "absolute",
            top: "3vw",
            right: "3vw",
            color: "#000000",
        },
        signInsignUpToggleText: {
            fontSize: "15px",
            [theme.breakpoints.only("xs")]: {
                fontSize: "14px",
            },
        },
        horizontalBarDivider: {
            width: "100%",
            margin: "10px 0px 6px 0px",
            [theme.breakpoints.up("sm")]: {
                display: "none",
            },
        },
        horizontalContent: {
            width: "100%",
        },
        // Floating header (sharescreen mode only). Overlays the content at the top.
        floatingHeader: {
            position: "absolute",
            top: "5vw",
            left: 0,
            width: "100%",
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "center",
            zIndex: 15000,
            pointerEvents: "none",
        },
        headerBar: {
            position: "relative",
            width: "85vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#ffffff",
            borderRadius: "1000px",
            padding: "2vw 3vw",
            boxShadow: "0px 0.6vw 2.4vw rgba(0, 0, 0, 0.13)",
        },
        liveIndicator: {
            display: "flex",
            alignItems: "center",
            gap: "1.4vw",
            backgroundColor: "#0a0a0a",
            borderRadius: "1000px",
            padding: "0.6vw 2.6vw",
        },
        liveDot: {
            width: "3vw",
            height: "3vw",
            borderRadius: "50%",
            backgroundColor: "rgb(230, 22, 22)",
            animation: "$liveBlink 0.7s ease-in-out infinite",
        },
        liveText: {
            fontWeight: 500,
            paddingTop: "0.5vw",
            fontSize: "3.6vw",
            letterSpacing: "0.2vw",
            color: "#ffffff",
        },
        statusText: {
            fontWeight: 400,
            fontSize: "2.5vw",
            color: "#9b9b9b",
            whiteSpace: "nowrap",
            marginLeft: "1.7vw",
        },
        // Wrapper reserves horizontal space for the card while keeping the bar
        // short; the card itself is absolutely centered so it pops out vertically.
        headerCardSlot: {
            position: "relative",
            alignSelf: "stretch",
            width: "13vw",
        },
        headerCard: {
            position: "absolute",
            left: "50%",
            top: "65%",
            transform: "translate(-50%, -50%)",
        },
        // Inner wrapper handles the wiggle so it doesn't fight headerCard's
        // centering transform. Wiggles briefly then rests over each 3s cycle.
        headerCardWiggle: {
            transformOrigin: "center bottom",
            animation: "$cardWiggle 3s ease-in-out infinite",
        },
        headerName: {
            fontWeight: 600,
            fontSize: "4vw",
            color: "#121212",
            whiteSpace: "nowrap",
            marginLeft: "1.7vw",
            marginRight: "2vw",
        },
        "@keyframes liveBlink": {
            "0%": { opacity: 1 },
            "50%": { opacity: 0.15 },
            "100%": { opacity: 1 },
        },
        // Wiggle concentrated in the first ~0.5s, then still for the rest of the 3s.
        "@keyframes cardWiggle": {
            "0%": { transform: "rotate(0deg)" },
            "2%": { transform: "rotate(-7deg)" },
            "5%": { transform: "rotate(6deg)" },
            "8%": { transform: "rotate(-5deg)" },
            "11%": { transform: "rotate(4deg)" },
            "14%": { transform: "rotate(-2deg)" },
            "17%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(0deg)" },
        },
    })
);

const Transition = React.forwardRef(function Transition(props: TransitionProps & { children?: React.ReactElement<any, any> }, ref: React.Ref<unknown>) {
    return <Slide direction="up" ref={ref} {...props} timeout={170} />;
});

// When the sharescreen sits idle (no socket state change) for this long, we
// autoplay a promotional video overlay until the next state change arrives.
const IDLE_VIDEO_DELAY_MS = 17000;
// TODO: replace with the real promotional video URL. Placeholder is a public
// Cloudinary demo clip cropped to 9:16 (720x1280) for testing the idle flow.
const PROMO_VIDEO_URL = 'https://studiosclo.uk/general/offline_idle_video_1.MOV';
// Bump the version suffix if PROMO_VIDEO_URL changes to invalidate old cached copies.
const IDLE_VIDEO_CACHE_NAME = 'offline-idle-video-v1';

export default function OverlayView({isLivescreen=false}: {isLivescreen?: boolean}) {
    const classes = useStyles();
    const dispatch = useAppDispatch();

    const [isRed, setIsRed] = React.useState(true);

    const overlayView = useAppSelector((state) => state.overlayOffline);

    const productsDictionary = useAppSelector(state => state.productsList.productsDictionary);

    const liveOfflineState = useAppSelector((state) => state.livestreamState.offlineSharescreenState);
    const firstName = liveOfflineState?.firstName ?? '';
    const currentBodyMeasurements: BodyMeasurements = liveOfflineState?.currentBodyMeasurements ?? {};
    const currentRegularSizeValue: RegularSizeValue = liveOfflineState?.currentRegularSizeValue ?? RegularSizeValue.M;
    const currentClothingType: ClothingType = liveOfflineState?.currentClothingType ?? ClothingType.KemejaPanjang;
    const currentScreenLive: OfflineActiveScreen = liveOfflineState?.currentScreen ?? OfflineActiveScreen.BenefitStart;
    const guidelinesData: any = liveOfflineState?.guidelinesData ?? undefined;
    const categoryTabIndex: (number | undefined) = liveOfflineState?.categoryTabIndex ?? undefined;
    const livestreamProductId: string = liveOfflineState?.livestreamProductId ?? '2026-05-PLPK-INBLACK';
    const livestreamProductCount: number = liveOfflineState?.livestreamProductCount ?? 0;
    const livestreamProductPrice: number = liveOfflineState?.livestreamProductPrice ?? 100000;
    const livestreamProductTimeLimit: number = liveOfflineState?.livestreamProductTimeLimit ?? '2028-05-06T00:00:00.000Z';

    const item = productsDictionary?.[livestreamProductId] ?? {};

    const microphoneState = useAppSelector((state) => state.microphoneState);

    const [childrenVisible, setChildrenVisible] = React.useState<boolean>(true);

    // Idle promo video (sharescreen mode only).
    const [showIdleVideo, setShowIdleVideo] = React.useState<boolean>(false);
    const idleVideoRef = React.useRef<HTMLVideoElement>(null);
    // Source actually fed to the <video>: a local blob URL once the clip has been
    // cached, otherwise the remote URL (streaming fallback).
    const [cachedVideoSrc, setCachedVideoSrc] = React.useState<string>(PROMO_VIDEO_URL);

    const manualOverride = false;
    const firstIn = false;

    // Reset the idle timer on every socket state change. liveOfflineState gets a
    // fresh object reference on each updateOfflineLiveState dispatch, so this
    // effect re-runs on any activity: hide the video and restart the 10s timer.
    // After 10s without a change we show the promo video overlay instead.
    useEffect(() => {
        if (isLivescreen) {
            return; // Idle video is only for the socket-following sharescreen.
        }
        setShowIdleVideo(false);
        const idleTimer = setTimeout(() => {
            setShowIdleVideo(true);
        }, IDLE_VIDEO_DELAY_MS);
        return () => clearTimeout(idleTimer);
    }, [liveOfflineState, isLivescreen]);

    // When the overlay appears, restart the clip and ensure it plays. Autoplay
    // with sound can be blocked, so fall back to muted playback if needed.
    useEffect(() => {
        if (!showIdleVideo) {
            return;
        }
        const video = idleVideoRef.current;
        if (!video) {
            return;
        }
        video.currentTime = 0;
        const playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {
                video.muted = true;
                video.play().catch(() => {});
            });
        }
    }, [showIdleVideo]);

    // Cache the (large) promo video locally so it is not re-downloaded on every
    // idle trigger or page reload. We fetch it once into the Cache Storage API and
    // play it from an in-memory blob URL. Runs on mount so caching is usually done
    // before the first idle. Falls back to streaming the remote URL when the Cache
    // API is unavailable (e.g. non-secure context) or the fetch fails (e.g. CORS).
    useEffect(() => {
        if (isLivescreen || !PROMO_VIDEO_URL) {
            return;
        }
        let cancelled = false;
        let objectUrl = '';

        (async () => {
            try {
                if (!('caches' in window)) {
                    return; // Keep the streaming fallback in place.
                }
                const cache = await caches.open(IDLE_VIDEO_CACHE_NAME);
                let response = await cache.match(PROMO_VIDEO_URL);
                if (!response) {
                    const networkResponse = await fetch(PROMO_VIDEO_URL, { mode: 'cors' });
                    if (networkResponse && networkResponse.ok) {
                        await cache.put(PROMO_VIDEO_URL, networkResponse.clone());
                        response = networkResponse;
                    }
                }
                if (response) {
                    const blob = await response.blob();
                    objectUrl = URL.createObjectURL(blob);
                    if (!cancelled) {
                        setCachedVideoSrc(objectUrl);
                    } else {
                        URL.revokeObjectURL(objectUrl);
                    }
                }
            } catch (e) {
                // Ignore: the streaming fallback (PROMO_VIDEO_URL) stays in place.
            }
        })();

        return () => {
            cancelled = true;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [isLivescreen]);

    useEffect(() => {
        // 2. Set up the interval for 1000 milliseconds (1 second)
        const interval = setInterval(() => {
            if (isLivescreen) {
                setIsRed((prevColor) => !prevColor);
            }
        }, 700);

        // 3. Clean up the interval when the component unmounts
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        dispatch(
            openOverlay()
        );
    }, [dispatch]);

    useEffect(() => {
        delayedDispatch(currentScreenLive);
    }, [currentScreenLive]);

    function delayedDispatch(currentScreen: OfflineActiveScreen) {
        setChildrenVisible(false);
        setTimeout(() => {
            dispatch(updateCurrentScreen(currentScreen));
            setChildrenVisible(true);
        }, 1000);
    }

    function closeOverlayAndResetUserMeasurementDraft() {
        delayedDispatch(OfflineActiveScreen.StandardBrowsing); // BACK TO STANDARD BROWSING
    }

    let content: JSX.Element = FlowComponentMaster(
        {
            firstName: firstName,
            microphoneState: microphoneState,
        },
        {
            currentScreen: overlayView.currentScreen,
            titleNumber: 0,
            currentBodyMeasurements: currentBodyMeasurements,
            currentClothingType: currentClothingType,
            currentRegularSizeValue: currentRegularSizeValue,
            manualOverride: manualOverride,
            firstIn: firstIn,
            guidelinesData: guidelinesData,
            categoryTabIndex: categoryTabIndex,
        }
    );

    return (
        <Dialog
            fullScreen
            maxWidth="lg"
            open={overlayView.status === UIOverlayViewStatus.On}
            TransitionComponent={Transition}
            // keepMounted
            onClose={closeOverlayAndResetUserMeasurementDraft}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            className={classes.dialogContainer}
        >
            {
                isLivescreen ? 
                <div style={{display: 'flex', width: '100%', height: '50vw', 
                    boxShadow: '0px 0px 10vw rgba(0, 0, 0, 0.2)', backgroundColor: '#fff', zIndex: 10000}}>
                    <div style={{width: '30%', padding: '5% 0% 5% 5%'}}>
                        {
                            item?.productImages ? 
                            <AlternatingImgCarsl displayImageList={item?.productImages ?? []} startingIndex={0}/>:
                            null
                        }
                        {/* <PageElementProduct 
                        product_id={item.productId}
                        image_url={'animate-carsl-1'} 
                        image_url_hover={item.displayImageHover} 
                        title={''}
                        discountedPrice={item.discountedPrice}
                        originalPrice={item.originalPrice}
                        isSoldOut={item.isSoldOut}
                        isComingAgainSoon={item.isComingAgainSoon}
                        product_url={`/shop/product/` + item.productId} 
                        /> */}
                    </div>
                    <div style={{padding: '5%'}}>
                        <Typography style={{
                            fontSize: '3vw', fontWeight: 500, letterSpacing: '0.3vw', 
                            color: '#fff', backgroundColor: isRed ? 'rgb(200, 6, 6)' : '#121212', padding: '1vw 3vw 0.5vw', borderRadius: '1000px',
                            width: 'fit-content', position: 'relative'}}><i>FLASH SALE</i></Typography>
                        <Typography style={{fontWeight: 500, fontSize: '2.5vw', lineHeight: '6.3vw', marginTop: '2vw', maxLines: 1, textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',}}>{ReactHtmlParser(item.name)}</Typography>
                        <Typography style={{fontWeight: 400, fontSize: '4vw', color: 'rgb(200,6,6)', textDecoration: 'line-through', marginTop: '0.5vw'}}>{("Rp " + item.originalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</Typography>
                        <Box style={{display: 'flex', alignItems: 'center', marginTop: '-1vw'}}>
                            <Typography style={{fontWeight: 500, fontSize: '5.5vw', paddingTop: '1.5vw'}}>{("Rp " + livestreamProductPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</Typography>
                            <Countdown
                            date={livestreamProductTimeLimit}
                            renderer={({ hours, minutes, seconds, completed }: any) => {
                                // const classes = useStyles();
                            
                                if (completed) {
                                return (
                                <div/>);
                                } else {
                                return (
                                <Box style={{
                                    marginLeft: '1.2vw',
                                    width: 'fit-content',
                                    padding: '0px 0px 0px 0px',
                                    textAlign: 'center',
                                }}>
                                    <Typography style={{
                                    fontSize: '3.1vw',
                                    fontFamily: 'OakesGrotesk', borderRadius: '1000px', padding: '0.8vw 2vw 0.3vw', 
                                    backgroundColor: 'rgb(200, 6, 6)', color: '#fff',
                                    // border: '1px solid black', color: '#121212',
                                    fontWeight: 500,
                                    }}>{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</Typography>
                                </Box>)
                                }
                            }}
                            onComplete={(timeDelta, completedOnStart) => {
                            }}
                            />
                        </Box>
                        <Typography style={{fontWeight: 300, fontSize: '3.2vw', letterSpacing: '0.12vw', marginTop: '3vw'}}><i>SISA {livestreamProductCount} LAGI!</i></Typography>
                    </div>
                </div>
                : null
            }
            {
                // Floating header for sharescreen mode. Overlays the content and is
                // hidden while the idle promo video is playing.
                !isLivescreen && !showIdleVideo ?
                <Box className={classes.floatingHeader}>
                    <Box className={classes.headerBar}>
                        <Box style={{display: 'flex', alignItems: 'center'}}>
                            <Box className={classes.liveIndicator}>
                                <Box className={classes.liveDot} />
                                <Typography className={classes.liveText}>LIVE</Typography>
                            </Box>
                            <Typography className={classes.statusText}>SEDANG MENGUKUR</Typography>
                        </Box>
                        <Box style={{display: 'flex', alignItems: 'center'}}>
                            <Box className={classes.headerCardSlot}>
                                <Box className={classes.headerCard}>
                                    <Box className={classes.headerCardWiggle}>
                                        <UkuranBadanCardMini nama={firstName ? firstName : '-'} width={"13vw"} fontSize={"2vw"} />
                                    </Box>
                                </Box>
                            </Box>
                            <Typography className={classes.headerName}>{firstName ? firstName : '-'}</Typography>
                        </Box>
                    </Box>
                </Box>
                : null
            }
            {
                !isLivescreen ? 
                <Box style={{width: '100%', height: '10vh'}}></Box>: null
            }
            <div className={classes.dialogContentContainer} style={{justifyContent: 'center', alignItems: 'center', height: isLivescreen ? '80%' : '90%'}}>
                <Grid container>
                    <Grid item xs={12}>
                        <Fade in={overlayView.status === UIOverlayViewStatus.On && childrenVisible} timeout={400}>
                            {content}
                        </Fade>
                    </Grid>
                </Grid>
            </div>
            {
                // Idle promo video overlay. Covers the whole sharescreen while idle
                // and is unmounted the moment a new socket state change arrives.
                showIdleVideo && cachedVideoSrc ?
                <Box style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#000',
                    zIndex: 20000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <video
                        ref={idleVideoRef}
                        src={cachedVideoSrc}
                        autoPlay
                        loop
                        playsInline
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                </Box>
                : null
            }
        </Dialog>
    );
}
